import { isGlobalFeatureEnabled } from './isFeatureEnabled';

/**
 * Kill switch for Mark As Read numeric delay UI and behavior.
 * When enabled, the app should use legacy behavior instead of the new numeric delay.
 */
export default function isMarkAsReadNumericDelayDisabled(): boolean {
    return isGlobalFeatureEnabled('settings-disableMarkAsReadNumericDelay');
}
